import { createContext } from "react";

export const PermissionContext = createContext({
  canEdit: false,
  canSync: false,
});
